export class CrossOriginWorkerMaker {
    constructor(url) {
        if (!IS_PRODUCTION) {
            this.worker = new Worker(url);
        }
        else {
            const workerBlob = new Blob([`importScripts(${JSON.stringify(url.toString())});`], {
                type: 'application/javascript',
            });
            const workerBlobUrl = URL.createObjectURL(workerBlob);
            this.worker = new Worker(workerBlobUrl);
            URL.revokeObjectURL(workerBlobUrl);
        }
    }
}
